var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGenerativeAiSolid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7874 3.20689C12.723 3.03276 12.4767 3.03276 12.4123 3.20689L12.1898 3.80826C11.9872 4.3557 11.5556 4.78732 11.0081 4.98989L10.4068 5.21242C10.2326 5.27685 10.2326 5.52312 10.4068 5.58756L11.0081 5.81008C11.5556 6.01265 11.9872 6.44428 12.1898 6.99171L12.4123 7.59308C12.4767 7.76721 12.723 7.76721 12.7874 7.59308L13.01 6.99171C13.2125 6.44428 13.6442 6.01265 14.1916 5.81008L14.793 5.58756C14.9671 5.52312 14.9671 5.27685 14.793 5.21242L14.1916 4.98989C13.6442 4.78732 13.2125 4.3557 13.01 3.80826L12.7874 3.20689ZM8.28743 5.00689C8.223 4.83276 7.97672 4.83276 7.91229 5.00689L6.96052 7.57901C6.75795 8.12645 6.32633 8.55807 5.77889 8.76064L3.20676 9.71242C3.03264 9.77685 3.03264 10.0231 3.20676 10.0876L5.77889 11.0393C6.32633 11.2419 6.75795 11.6735 6.96052 12.221L7.91229 14.7931C7.97672 14.9672 8.223 14.9672 8.28743 14.7931L9.23921 12.221C9.44178 11.6735 9.8734 11.2419 10.4208 11.0393L12.993 10.0876C13.1671 10.0231 13.1671 9.77685 12.993 9.71242L10.4208 8.76064C9.8734 8.55807 9.44178 8.12645 9.23921 7.57901L8.28743 5.00689Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerativeAiSolid);
export default __webpack_public_path__ + "static/media/GenerativeAISolid.e2f5ce85a3a996087a3936c28888161f.svg";
export { ForwardRef as ReactComponent };